<template>
    <Page :header="header[lang].name" :header_pos="'center'">
        <template #body>
            <div class="flex justify-content-center flex-wrap card-container">

                <!--TELEGRAM AUTH-->
                <AuthTgButton />

                <Divider align="center" type="dotted">
                    <span class="text-500">{{ fields[lang].or }}</span>
                </Divider>

                <AuthForm />
                
                <Divider />
                
                <div class="card">
                    <div class="flex justify-content-center flex-wrap card-container yellow-container">
                        <div class="flex align-items-center justify-content-center w-full m-2 gap-2">
                            <Button :label="buttons[lang].registation" @click="go_reg" text severity="info"/>
                            <Button :label="buttons[lang].forgot_password" @click="go_pass" text severity="info"/>
                        </div>
                    </div>
                </div>

			</div>
        </template>
    </Page>
</template>


<script>
import Connect from         '@/assets/js/Connect'
import Event from           '@/assets/js/Event'
import Page from            '@/components/sides/Page.vue'
import AuthForm from        '@/components/public/auth/AuthForm.vue' 
import AuthTgButton from    '@/components/widgets/AuthTgButton.vue' 
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header:{
                en: {name: "Authorization"} ,
                ru: {name: "Авторизация"} ,
            },
            fields:  {
                en:{
                    or: "or",
                },
                ru:{
                    or: "или",
                }                 
            },
            buttons:  {
                en:{
                    login : "Login",
                    registation: "Registration",
                    forgot_password: "Forgot password",
                },
                ru:{
                    login : "Войти",
                    registation: "Регистрация",
                    forgot_password: "Забыл пароль",
                }
                 
            }, 
        }
    },
    components: {
        Page,
        AuthForm,
        AuthTgButton
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        go_reg() {
            this.event.send('regBtn')
            this.$router.push({ path: '/reg/' })
        },
        go_pass() {
            this.event.send('forgotBtn')
            this.$router.push({ path: '/pass/' })
        },
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isAuth: function () { return this.$store.getters.isAuthenticated },
    },
    beforeCreate(){
        this.connect = new Connect()
        this.event = new Event(this)
    },
    mounted(){
        if(this.isAuth) this.$router.push({ path: '/' })

        try {
            this.SetHeaderTitle(null)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/reg/',
                label: this.buttons[this.lang].registation,
                icon: 'pi pi-user-plus',
                iconPos: 'right',
                rounded: true,
                visible: true
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>